import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;

const axios = createClient({ baseUrl, isAdminSite: true });

export const getComingSoonPages = () => {
  return axios.get("/coming-soon-page");
};

export const updateComingSoonPage = (data) => {
  return axios.post("/update-coming-soon-page", data);
};
